<div class="cv-lp-shell">
  <div class="cv-lp" role="region" aria-label="Layers panel">

    <div class="cv-lp__header" *ngIf="showHeader">
      <div class="cv-lp__title-row">
        <svg class="cv-lp__title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polygon points="12 2 2 7 12 12 22 7 12 2"/>
          <polyline points="2 17 12 22 22 17"/>
          <polyline points="2 12 12 17 22 12"/>
        </svg>
        <h2 class="cv-lp__title">Layers</h2>
        <span class="cv-lp__count" *ngIf="layers.length > 0">{{ layers.length }}</span>
        <button
          *ngIf="layers.length > 0"
          type="button"
          class="cv-lp__clear-all"
          (click)="clearAllLayers.emit()"
          aria-label="Clear all layers"
          title="Clear all"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M9 3V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z"/>
          </svg>
        </button>
      </div>
      <button type="button" class="cv-lp__collapse" (click)="closePanel.emit()" title="Close layers panel" aria-label="Close layers panel">
        <!-- collapse-panel icon: bracket + chevron -->
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="16" height="16" rx="3"/>
          <line x1="7" y1="2" x2="7" y2="18"/>
          <polyline points="12 7 9.5 10 12 13"/>
        </svg>
      </button>
    </div>

    <div class="cv-lp__list" *ngIf="layers.length > 0; else empty">
      <div
        class="cv-lp__row"
        *ngFor="let layer of displayLayers(); trackBy: trackById; let i = index"
        [attr.data-layer-row-id]="layer.id"
        [style.--shape-color]="shapeColor(layer)"
        [style.--shape-bg]="shapeBgColor(layer)"
        [style.--row-i]="i"
        [class.cv-lp__row--hidden]="!layer.visible"
        [class.cv-lp__row--draggable]="canDragRow(layer)"
        [class.cv-lp__row--enter]="isEnteringRow(layer.id)"
        [class.cv-lp__row--drag-active]="draggingLayerId() === layer.id"
        (pointerdown)="onRowPointerDown(layer.id, $event)"
        (click)="onRowClick(layer, $event)"
      >
        <!-- Colored shape badge (drag handle) -->
        <span
          class="cv-lp__badge"
          [class.cv-lp__badge--draggable]="canDragRow(layer)"
          [attr.title]="canDragRow(layer) ? 'Drag to reorder layer' : null"
        >
          <svg class="cv-lp__badge-svg" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <circle *ngIf="layer.shape === 'circle'" cx="7" cy="7" r="5.2" stroke="var(--shape-color)" stroke-width="1.5" fill="var(--shape-bg)"/>
            <rect *ngIf="layer.shape === 'rectangle'" x="1.5" y="2.5" width="11" height="9" rx="1.5" stroke="var(--shape-color)" stroke-width="1.5" fill="var(--shape-bg)"/>
            <polygon *ngIf="layer.shape === 'polygon'" points="7,1.5 12.5,5 10.5,12 3.5,12 1.5,5" stroke="var(--shape-color)" stroke-width="1.5" stroke-linejoin="round" fill="var(--shape-bg)"/>
            <g *ngIf="layer.shape === 'marker'" stroke="var(--shape-color)" stroke-width="1.4" stroke-linecap="round" fill="var(--shape-bg)">
              <path d="M7 1.75a3.25 3.25 0 0 0-3.25 3.25c0 2.2 2.4 5.15 3.25 6.35.85-1.2 3.25-4.15 3.25-6.35A3.25 3.25 0 0 0 7 1.75z"/>
              <circle cx="7" cy="5" r="1.15" fill="var(--shape-color)" stroke="none"/>
            </g>
            <g *ngIf="layer.shape === 'dataset'" stroke="var(--shape-color)" stroke-width="1.4" stroke-linejoin="round" fill="var(--shape-bg)">
              <polygon points="7,1.5 12.5,4.5 12.5,9.5 7,12.5 1.5,9.5 1.5,4.5"/>
              <polyline points="7,4 7,8.5" fill="none"/>
              <polyline points="4.5,6 9.5,6" fill="none"/>
            </g>
          </svg>
        </span>

        <div class="cv-lp__name">
          <input
            *ngIf="layer.rowState === 'editing'"
            class="cv-lp__input"
            type="text"
            [ngModel]="layer.name"
            (ngModelChange)="onNameInput(layer, $event)"
            [placeholder]="layer.defaultLabel"
            [attr.aria-label]="'Layer name'"
            [attr.data-layer-id]="layer.id"
            autocomplete="off"
          />

          <button
            *ngIf="layer.rowState === 'saved' || layer.rowState === 'reset'"
            type="button"
            class="cv-lp__label-btn"
            (click)="onLabelClick(layer)"
            title="Click to rename"
            [attr.aria-label]="'Rename: ' + layer.name"
          >
            <span class="cv-lp__label-text">{{ layer.name }}</span>
            <svg class="cv-lp__label-edit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </button>
        </div>

        <div class="cv-lp__controls">
          <div class="cv-lp__style" *ngIf="showStyleControls(layer)">
            <div
              *ngIf="layer.styleControls.color"
              class="cv-lp__color-picker"
              title="Layer color"
            >
              <input
                type="color"
                class="cv-lp__color-input"
                [value]="layer.layerColor"
                [id]="'cv-layer-color-' + layer.id"
                (input)="onColorInput(layer.id, $event)"
                aria-label="Layer color"
              />
              <label
                class="cv-lp__color-swatch"
                [for]="'cv-layer-color-' + layer.id"
                [style.backgroundColor]="layer.layerColor"
              ></label>
            </div>

            <lib-canvas-marker-picker
              *ngIf="layer.styleControls.marker"
              [iconsBaseUrl]="iconsBaseUrl"
              [selectedIconId]="layer.markerIconId"
              (iconChange)="layerMarkerChange.emit({ id: layer.id, iconId: $event })"
            ></lib-canvas-marker-picker>

            <div *ngIf="layer.styleControls.opacity" class="cv-lp__opacity">
              <input
                type="range"
                class="cv-lp__opacity-slider"
                min="0"
                max="100"
                step="1"
                [value]="layer.layerOpacity * 100"
                (input)="onOpacityInput(layer.id, $event)"
                aria-label="Layer opacity"
              />
              <span class="cv-lp__opacity-label">{{ layer.layerOpacity * 100 | number:'1.0-0' }}%</span>
            </div>
          </div>

          <button
            type="button"
            class="cv-lp__vis"
            (click)="toggleVisibility.emit(layer.id)"
            [title]="layer.visible ? 'Hide on map' : 'Show on map'"
            [attr.aria-label]="layer.visible ? 'Hide layer' : 'Show layer'"
          >
            <svg *ngIf="layer.visible" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="!layer.visible" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          </button>

          <div class="cv-lp__actions">
            <ng-container *ngIf="layer.rowState === 'editing'">
              <button type="button" class="cv-lp__icon-btn cv-lp__icon-btn--save" (click)="saveName.emit(layer.id)" title="Save name" aria-label="Save name">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </button>
              <button type="button" class="cv-lp__icon-btn cv-lp__icon-btn--reset" (click)="resetToDefault.emit(layer.id)" title="Reset to default name" aria-label="Reset to default name">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                  <path d="M3 3v5h5"/>
                </svg>
              </button>
            </ng-container>

            <div class="cv-lp__kebab-wrap" *ngIf="layer.rowState === 'saved' || layer.rowState === 'reset'">
              <button
                type="button"
                class="cv-lp__icon-btn cv-lp__icon-btn--kebab"
                (click)="toggleKebab(layer.id, $event)"
                [class.cv-lp__icon-btn--active]="openKebabId() === layer.id"
                title="More options"
                aria-label="More options"
                [attr.aria-expanded]="openKebabId() === layer.id"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <circle cx="12" cy="5" r="2"/>
                  <circle cx="12" cy="12" r="2"/>
                  <circle cx="12" cy="19" r="2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #empty>
      <div class="cv-lp__empty">
        <div class="cv-lp__empty-icon-wrap">
          <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <rect x="6" y="28" width="36" height="10" rx="3" fill="var(--canvas-primary-border)" stroke="var(--canvas-action)" stroke-width="1.6"/>
            <rect x="6" y="16" width="36" height="10" rx="3" fill="var(--canvas-primary-bg)" stroke="var(--canvas-action)" stroke-width="1.6" opacity="0.75"/>
            <rect x="6" y="4"  width="36" height="10" rx="3" fill="var(--canvas-primary-bg-faint)" stroke="var(--canvas-action)" stroke-width="1.6" opacity="0.45"/>
            <path d="M20 33h8M20 21h8M20 9h8" stroke="var(--canvas-action)" stroke-width="1.4" stroke-linecap="round" opacity="0.6"/>
          </svg>
        </div>
        <p class="cv-lp__empty-title">No layers available</p>
        <p class="cv-lp__empty-hint">
          Draw shapes, add markers, or load a dataset on the map — each appears here as a layer.
        </p>
      </div>
    </ng-template>

  </div>

  <!-- Fixed-position kebab menu — outside .cv-lp to avoid overflow:hidden clipping -->
  <div
    class="cv-lp__menu cv-lp__menu--fixed"
    *ngIf="openKebabId() as menuLayerId"
    role="menu"
    [style.top.px]="kebabMenuTop()"
    [style.left.px]="kebabMenuLeft()"
    (click)="$event.stopPropagation()"
  >
    <button type="button" class="cv-lp__menu-item" role="menuitem" (click)="onMenuEdit(menuLayerId)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
      Edit name
    </button>
    <button type="button" class="cv-lp__menu-item cv-lp__menu-item--danger" role="menuitem" (click)="onMenuDelete(menuLayerId)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <polyline points="3 6 5 6 21 6"/>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
        <path d="M10 11v6M14 11v6"/>
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
      </svg>
      Delete layer
    </button>
    <button type="button" class="cv-lp__menu-item" role="menuitem" (click)="onMenuExport(menuLayerId)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export layer
    </button>
    <button type="button" class="cv-lp__menu-item" role="menuitem" (click)="onMenuZoomToBounds(menuLayerId)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/>
        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <line x1="11" y1="8" x2="11" y2="14"/>
        <line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
      Zoom to bound
    </button>
    <button
      *ngIf="aboutMenuVisible()"
      type="button"
      class="cv-lp__menu-item"
      role="menuitem"
      (click)="onMenuAbout(menuLayerId)"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
      About
    </button>
  </div>
</div>
